import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import styles from './RNAI/Form.module.css';
import { FaPencilAlt } from 'react-icons/fa';

export default function EditFundingItem({
  id,
  action,
  index,
  dialogTitle,
  dialogContentText,
  children,
}) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (event) => {
    event.stopPropagation();
    setOpen(true);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    setOpen(false);
  };

  return (
    <React.Fragment>
      {children ? (
        <div onClick={handleClickOpen}>{children}</div>
      ) : (
        <img
          src={`${process.env.PUBLIC_URL}/pen.svg`}
          alt="edit"
          className="detail-icon clickable"
          style={{ border: 'none' }}
          height={18}
          onClick={handleClickOpen}
        />
      )}

      <Dialog
        open={open}
        onClick={(event) => event.stopPropagation()}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{dialogContentText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button sx={{ color: '#1976d2' }} onClick={handleClose}>
            Cancel
          </Button>
          <Button
            sx={{ color: '#1976d2' }}
            onClick={async () => {
              await action(id, index);
              setOpen(false);
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
